import api from "shared/api";
import { AxiosPromise } from "axios";
import { InsertMessage } from "./models/insert-message";
import { Message } from "./models/message";

const prefix = "api/contact";

export const postMessage = (message: InsertMessage): AxiosPromise<void> => {
  return api().post(`${prefix}/messages`, message);
};

export const getMessages = async (): Promise<Message[]> => {
  const res = await api().get<Message[]>(`${prefix}/messages`);
  return res.data;
};

export const getMessageBody = async (id: number): Promise<string> => {
  const res = await api().get<{ body: string }>(
    `${prefix}/messages/${id}/body`
  );
  return res.data.body;
};
